import React, { useContext, useEffect, useState } from 'react';
import { Flex } from 'antd';

import Count from '@totem/components/common/Count';
import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import { Criticality } from '@totem/types/criticality';
import { isNotNull } from '@totem/utilities/common';
import { criticalityMap } from '@totem/utilities/criticalityUtilities';
import { getExactPercentage } from '@totem/utilities/numberUtilities';

import './auditReport.css';

const INCLUDED_CRITICALITIES = [
  Criticality.Critical,
  Criticality.High,
  Criticality.Medium,
  Criticality.Low,
];

const styles = {
  fullWidthCentered: {
    width: '100%',
    alignItems: 'center',
  },
  findingHeaderContainer: {
    marginBottom: '16px',
  },
};

const FindingsByCriticality = () => {
  const { data } = useContext(SurveyContext);
  const [criticalityCounts, setCriticalityCounts] = useState<number[]>([
    0, 0, 0, 0, 0, 0,
  ]);

  useEffect(() => {
    const criticalityGrouping: number[] = [0, 0, 0, 0, 0, 0];

    if (isNotNull(data)) {
      for (let cIdx = 0; cIdx < data.survey.categories.length; cIdx++) {
        const category = data.survey.categories[cIdx];
        if (category.visible) {
          const questionsWithFindings = category.questions.filter(
            (chk) =>
              (chk.type === 'enumsingle' || chk.type === 'scored') &&
              chk.policy !== '' &&
              chk.visible,
          );

          for (let qIdx = 0; qIdx < questionsWithFindings.length; qIdx++) {
            const question = questionsWithFindings[qIdx];
            const optionIdx = question.options.findIndex(
              (chk) => chk.label === question.value.value,
            );

            if (optionIdx >= 0) {
              const criticality = question.options[optionIdx].criticality;

              if (criticality > 0) {
                criticalityGrouping[criticality] += 1;

                if (criticality >= 1 && criticality <= 4) {
                  criticalityGrouping[0] += 1;
                }
              }
            }
          }
        }
      }
    }

    setCriticalityCounts(criticalityGrouping);
  }, [data]);

  return (
    <div>
      <Flex
        justify={'space-between'}
        align={'flex-start'}
        style={styles.findingHeaderContainer}
      >
        <div styleName="finding-header">Findings By Criticality</div>
        <Count count={criticalityCounts[0]} size="large" />
      </Flex>
      <div>
        {INCLUDED_CRITICALITIES.map((criticality) => {
          const option = criticalityMap[criticality];

          const percentage = getExactPercentage(
            criticalityCounts[0],
            criticalityCounts[criticality],
          );

          return (
            <Flex justify={'flex-start'} align={'flex-start'} key={criticality}>
              <div styleName="finding-label criticality">{option.text}</div>
              <Flex style={styles.fullWidthCentered}>
                <div styleName="finding-bar-clean">
                  <div
                    style={{
                      width: `${percentage}%`,
                      background: option.color,
                      height: '100%',
                    }}
                  />
                </div>
              </Flex>
              <Count count={criticalityCounts[criticality]} size="small" />
            </Flex>
          );
        })}
      </div>
    </div>
  );
};

export default FindingsByCriticality;
